/**
 =========================================================
 * Material Dashboard 2 PRO React - v2.1.0
 =========================================================

 * Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
 * Copyright 2022 Creative Tim (https://www.creative-tim.com)

 Coded by www.creative-tim.com

 =========================================================

 * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
 */

// @mui material components
import Grid from "@mui/material/Grid";

// Material Dashboard 2 PRO React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import FormField from "../FormField";
import MDDatePicker from "../../../../../../components/MDDatePicker";
import { Autocomplete, Divider, Switch, TextField } from "@mui/material";
import MDEditorField from "../MDEditorField";
import MDInput from "../../../../../../components/MDInput";
import { useMeQuery } from "../../../../../../store/api/auth";
import MDProgress from "../../../../../../components/MDProgress";
import { DateTimePicker } from "@mui/x-date-pickers";
import { format } from "date-fns";


// NewProduct page components

function EventInfo({ formData }) {
  const { data: user } = useMeQuery();
  const { formField, values, errors, touched, setFieldValue } = formData;
  const { name, start_date, end_date, description, event_type, will_process } = formField;
  const {
    name: nameV,
    start_date: startDateV,
    end_date: endDateV,
    description: descriptionV,
    event_type: eventTypeV,
    will_process: willProcessV
  } = values;

  const eventTypeHandler = (e, newValue) => {
    setFieldValue("event_type", newValue.value);
  };
  const eventTypes = [
    {
      value: 1,
      label: "User Event"
    },
    {
      value: 2,
      label: "Local Event"
    }
  ];
  const storage = {
    max: user.subscription ? user.subscription[0].max_storage : 1,
    usage: user.subscription ? user.subscription[0].usage_storage : 0
  };
  const event_number = {
    max: user.subscription ? user.subscription[0].max_number_of_events : 1,
    usage: user.subscription ? user.subscription[0].usage_number_of_events : 0
  };
  const photo_process = {
    max: user.subscription ? user.subscription[0].max_number_of_process_photos : 1,
    usage: user.subscription ? user.subscription[0].usage_number_of_process_photos : 0
  };

  const proportions = {
    storage: storage.usage / storage.max * 100,
    event_number: event_number.usage / event_number.max * 100,
    photo_process: photo_process.usage / photo_process.max * 100
  };

  const getColor = (value) => {
    if (value < 50) {
      return "info";
    } else if (value >= 50 && value < 80) {
      return "warning";
    } else {
      return "error";
    }
  };

  return (
    <MDBox>
      <MDTypography variant="h5">Event Information</MDTypography>
      <MDBox mt={3}>
        <Grid container spacing={3}>
          <Grid item xs={12} sm={12}>
            <FormField
              type={name.type}
              label={name.label}
              name={name.name}
              value={nameV}
              placeholder={name.placeholder}
              error={errors.name && touched.name}
              success={nameV.length > 0 && !errors.name}
            />
          </Grid>
          <Grid item xs={12} sm={12}>
            <DateTimePicker
              label="Start Date"
              ampm={false}
              value={startDateV}
              onChange={(newValue) => {
                setFieldValue("start_date", newValue);
              }}
              renderInput={(params) => <TextField {...params} />}
            />
          </Grid>
          <Grid item xs={12} sm={12}>
            <DateTimePicker
              label="End Date"
              ampm={false}
              value={endDateV}
              onChange={(newValue) => {
                setFieldValue("end_date", newValue);
              }}
              renderInput={(params) => <TextField {...params} />}
            />
          </Grid>
        </Grid>
      </MDBox>
      <Divider />
      <MDBox mt={2}>
        <Grid container spacing={3}>
          <Grid item xs={12} sm={12}>
            <MDBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
              <MDTypography component="label" variant="button" fontWeight="regular" color="text">
                Description&nbsp;&nbsp;
              </MDTypography>
            </MDBox>
            <MDEditorField label={description.label}
                           name={description.name}
                           value={descriptionV} />
          </Grid>
        </Grid>
      </MDBox>
      <Divider />
      <MDBox mt={2}>
        <Grid container spacing={3}>
          <Grid item xs={12} sm={6}>
            <Autocomplete
              value={eventTypes.find(e => e.value === eventTypeV)}
              isOptionEqualToValue={(option, value) => option.id === value.id}
              getOptionLabel={(g) => g.label}
              options={eventTypes}
              onChange={eventTypeHandler}
              renderInput={(params) => <MDInput {...params} variant="standard" />}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <Switch checked={willProcessV} onChange={()=>setFieldValue("will_process", !willProcessV)} />
            <MDTypography variant="button" fontWeight="regular" color="text">
              Photos in this event will {!willProcessV?"not":""} processed
            </MDTypography>
          </Grid>
          <Grid item xs={12} sm={6}>
            <Grid item>
              <Grid container>
                <MDTypography variant="caption" color="text">
                  Usage/Max Storage:
                </MDTypography>
                <MDTypography variant="caption" color={getColor(proportions.storage)}>
                  {storage.usage}/{storage.max}
                </MDTypography>
              </Grid>
              <MDBox mt={0.25}>
                <MDProgress text={"test"} variant="gradient" value={proportions.storage}
                            color={getColor(proportions.storage)} />
              </MDBox>
            </Grid>
            <Grid item>
              <Grid container>
                <MDTypography variant="caption" color="text">
                  Usage/Max Number of Events:
                </MDTypography>
                <MDTypography variant="caption" color={getColor(proportions.event_number)}>
                  {event_number.usage}/{event_number.max}
                </MDTypography>
              </Grid>
              <MDBox mt={0.25}>
                <MDProgress text={"test"} variant="gradient" value={proportions.event_number}
                            color={getColor(proportions.event_number)} />
              </MDBox>
            </Grid>
            <Grid item>
              <Grid container>
                <MDTypography variant="caption" color="text">
                  Usage/Max Photo Process:
                </MDTypography>
                <MDTypography variant="caption" color={getColor(proportions.photo_process)}>
                  {photo_process.usage}/{photo_process.max}
                </MDTypography>
              </Grid>
              <MDBox mt={0.25}>
                <MDProgress text={"test"} variant="gradient" value={proportions.photo_process}
                            color={getColor(proportions.photo_process)} />
              </MDBox>
            </Grid>
          </Grid>
        </Grid>
      </MDBox>
    </MDBox>
  );
}

export default EventInfo;
